/**
 * Compares two values and returns true if they are different.
 * Handles Dates, arrays, and objects.
 */
const isDifferent = (val1, val2) => {
	// Handle null/undefined
	if (val1 == null && val2 == null) return false;
	if (val1 == null || val2 == null) return true;

	// Handle Date objects
	if (val1 instanceof Date && val2 instanceof Date) {
		return val1.getTime() !== val2.getTime();
	}

	// Handle arrays (shallow)
	if (Array.isArray(val1) && Array.isArray(val2)) {
		if (val1.length !== val2.length) return true;
		return val1.some((item, idx) => isDifferent(item, val2[idx]));
	}

	// Handle objects
	if (typeof val1 === "object" && typeof val2 === "object") {
		const keys1 = Object.keys(val1);
		const keys2 = Object.keys(val2);
		if (keys1.length !== keys2.length) return true;
		return keys1.some((key) => isDifferent(val1[key], val2[key]));
	}

	// Fallback to simple comparison
	return val1 !== val2;
};

/**
 * Creates a payload object containing only the fields that have changed
 * compared to the original data.
 *
 * @param {Object} data - Edited data
 * @param {Object} originalData - Original data before editing
 * @param {Object} columns - Columns mapping (optional, can filter keys)
 * @returns {Object} payload - Only changed key-value pairs
 */
export const createUpdatedDataPayload = (data, originalData, columns = null) => {
	const payload = {};
	const keys = columns ? Object.keys(columns) : Object.keys(data);

	keys.forEach((key) => {
		if (isDifferent(data[key], originalData[key])) {
			payload[key] = data[key];
		}
	});

	return payload;
};
